import { render } from "./NetworkError.vue?vue&type=template&id=6b9666f7"
const script = {}
script.render = render

export default script